import createCollectionResource from 'src/actions/shared/createResource';
import { Matches } from 'class-validator';
import { IsPropertyUniqueInStoreSlice } from '../validators/IsPropertyUniqueInStoreSlice';

class RelationshipLabel {
  id: string;

  @IsPropertyUniqueInStoreSlice('relationshipLabels', { message: 'This relationship already exists' })
  @Matches(/\S/, { message: 'Please name the relationship' })
  displayName: string;
}

const relationshipLabelsResource = createCollectionResource<RelationshipLabel>({
  name: 'relationshipLabels',
  endpoint: 'v1/orgs/:orgId/relationship-labels/:id',
  type: RelationshipLabel,
  options: {
    toastMessages: {
      onAdd: relationshipLabel => `Added "${relationshipLabel.displayName}"`,
      onUpdate: relationshipLabel => `Updated relationship to "${relationshipLabel.displayName}"`,
      onRemove: () => `Deleted relationship`,
    },
  },
});

export default relationshipLabelsResource;
